import { ReactComponent as AdvancedSearch } from './advanced-search.svg'

AdvancedSearch.defaultProps = {
    color: '#000000',
}

export default AdvancedSearch
